import { Identifiable, Project, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

type Response = Identifiable<Project> & {
  _links: {
    [key: string]: { href: string };
  };
};

function saveTaskStatus(httpClient: HttpClient) {
  return (project: Identifiable<Project>, status: Status) =>
    httpClient
      .sendHttpRequest<Identifiable<Status>>({
        endpoint: "/statuses",
        method: HttpMethods.POST,
        data: {
          ...status,
          percentComplete: status.percentComplete ?? null,
          project: `/projects/${project.uuid}`,
        },
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            completionDateOutOfBound: "completionDateOutOfBound",
            notFound: "notFound",
          }),
        ),
      );
}

export { saveTaskStatus };
